import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonFunctionService ,UserPOSData} from "./../../../services/Common/common-function.service";
import { Validators, FormControl } from "@angular/forms";
import { ActivatedRoute } from '@angular/router';
import { CustomerService } from '../../POSServices/Customers/customer.service';
const swal = require('sweetalert');


@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.scss']
})
export class CustomerComponent implements OnInit {
  Mobileerrormessage:any;
  mobileerrorvalidation:boolean=true;
  isReadytoUpdateCustomer : boolean = false;
  date= new FormControl("", [Validators.required]);
 
  mobileerror:any;
  Emailerror:any
  contactrefrence = [
    { text: "Email", value: "Email" },
    { text: "Text Message", value: "Text Message" },
    { text: "Phone Call", value: "Phone Call" },
    { text: "All", value: "All" },

  ];
merchantdata: UserPOSData ;
  isemployee: boolean = false;
isemailverify: boolean = false;
  isNewCustomer: boolean = true;
  isUpdateCustomer: boolean = false;
  rows;
  DateTime ;
  // customerId = new FormControl("", [Validators.required]);
 id= new FormControl("", [Validators.required]);
CustomerId = new FormControl("", [Validators.required]);
CustomerName  = new FormControl("", [Validators.required, Validators.minLength(1), Validators.pattern("^(?! )[a-zA-Zs ]*$")]);
Email  = new FormControl("", []);
MobileNo  =new FormControl("", [Validators.required, Validators.max(9999999999), Validators.min(1000000000), Validators.pattern("^(?! )[0-9]+?$")]);
Address  = new FormControl("", [Validators.required]);
BirthDay  = new FormControl("", []);
BusinessName  = new FormControl("", [Validators.required]);
Notes  = new FormControl("", []);
currency:any;
ContactPerference  = new FormControl("", [Validators.required]);
  constructor(
    private router: Router,
    private commonfunction: CommonFunctionService,
    private activatedRoute: ActivatedRoute,
    private service:CustomerService ,
  ) { }

  ngOnInit() {
    this.merchantdata = this.commonfunction.getUserPOSData();
    this.getGetCustomer();
    this.currency = this.commonfunction.GetCurrencysymbol();
  }
  getGetCustomer() {
    let form = { merchantKeyId: "", id: "", PosSubscriptionId:"" };
    this.activatedRoute.params.subscribe(params => {
      console.log(params["id"]);
      console.log(params["merchantKeyId"]);
     form.id = params["id"];
      form.merchantKeyId = params["merchantKeyId"];
      form.PosSubscriptionId  = this.merchantdata.PosSubscriptionId;
      console.log("formdata---" + form);
    });   

    this.service.GetCustomerDetail(form).subscribe(result => {   
      console.log("result.Id---" + result);
      if (result.Id > 0) {
        this.isUpdateCustomer = true;
        this.isNewCustomer = false;
        this.rows = result;
      } else {
        this.isUpdateCustomer = false;
        this.isNewCustomer = true;
      }
    });
 
  }

  EmailVerfication()
  {
    let form = { merchantKeyId: "", id:"", PosSubscriptionId:"" };
    this.activatedRoute.params.subscribe(params => {
      console.log(params["id"]);
      console.log(params["merchantKeyId"]);
      // form.id = params["id"];
  
      form.id = this.Email.value;
      form.merchantKeyId = params["merchantKeyId"];
      form.PosSubscriptionId  = this.merchantdata.PosSubscriptionId;
      console.log("formdata---" + form);
    });   

    this.service.GetCustomerEmailVerfication(form).subscribe(result => {   
      // console.log("result.Id---" + result);
      if(result==null)
      {
        this.isemailverify=false;
      }
      else{
        var email=this.Email.value;
        var demail=result.email;
        if(email==demail)
       {
        this.isemailverify=true;
       }
      }
    });
  }

  onChangemobile()
  {
    this.mobileerrorvalidation = this.commonfunction.Mobilenumbervalidation(this.MobileNo.value);
    if(this.mobileerrorvalidation==false)
    {
      this.Mobileerrormessage="";
      let form = { merchantKeyId: "", Email:"", PosSubscriptionId:"" ,MobileNumber:""};
      let merchantdata: UserPOSData = this.commonfunction.getUserPOSData();
      this.activatedRoute.params.subscribe(params => {
        console.log(params["id"]);
        console.log(params["merchantKeyId"]);
        form.Email = this.Email.value;
        form.MobileNumber=this.MobileNo.value;
        if(form.MobileNumber=="")
        {
          form.MobileNumber="undefined";
        }
        if(form.Email=="")
        {
          form.Email="undefined";
        }
        form.merchantKeyId = params["merchantKeyId"];   
        form.PosSubscriptionId  =merchantdata.PosSubscriptionId;
        console.log("formdata---" + form);
      });   
      this.service.GetcustomerMobiledetails(form).subscribe(result => {   
        if(result!=null)
        {
        
       if(this.MobileNo.value == result.mobileNo)
         {
          this.mobileerror=true;
  
         }
         else{
          this.mobileerror=false;
         }
        }
        else{
          this.mobileerror=false;
  
         }
       
      });
  
    }
    else
    {
      this.Mobileerrormessage="Enter valid Mobile Number"
    }
   
  }


  onChangeid()
  {
    let form = { merchantKeyId: "", Email:"", PosSubscriptionId:"" ,MobileNumber:""};
    let merchantdata: UserPOSData = this.commonfunction.getUserPOSData();
    this.activatedRoute.params.subscribe(params => {
      console.log(params["id"]);
      console.log(params["merchantKeyId"]);
      form.Email = this.Email.value;
      form.MobileNumber=this.MobileNo.value;
      if(form.MobileNumber=="")
      {
        form.MobileNumber="undefined";
      }
      if(form.Email=="")
      {
        form.Email="undefined";
      }
      form.merchantKeyId = params["merchantKeyId"];   
      form.PosSubscriptionId  =merchantdata.PosSubscriptionId;
      console.log("formdata---" + form);
    });   
    this.service.GetCustomerid(form).subscribe(result => {   
      if(result!=null)
      {
       if(this.Email.value == result.email)
       {
         this.Emailerror=true;
       }
       else{
        this.Emailerror=false;
       }
      }
      else{
        this.Emailerror=false;
       }
     
    });
  }





  onChange()
  {
    let form = { merchantKeyId: "", id:"", PosSubscriptionId:"" };
    this.activatedRoute.params.subscribe(params => {
      console.log(params["id"]);
      console.log(params["merchantKeyId"]);
      // form.id = params["id"];
  
      form.id = this.CustomerId.value;
      form.merchantKeyId = params["merchantKeyId"];
      form.PosSubscriptionId  = this.merchantdata.PosSubscriptionId;
      console.log("formdata---" + form);
    });   

    this.service.GetCustomerIDDetail(form).subscribe(result => {   
      // console.log("result.Id---" + result);
      if(result==null)
      {
        this.isemployee=false;
      }
      else{
       var cid=this.CustomerId.value;
       var rid=result.customerId;
       if(cid==rid)
       {
            this.isemployee=true;
       }
      
      }
    });
 
  }
  updateCustomer()
  {
    let form = {
      id:"",
      PosSubscriptionId:"",
      CustomerId :"",
      CustomerName  :"",
      Email  :"",
      MobileNo  :"",
      // Address  :"",
      BirthDay  :"",
      BusinessName  :"",
      Notes  :"",
      ContactPerference  :"",
      DateTime:"",
      };
      form.CustomerId = this.CustomerId.value;
      form.CustomerName = this.CustomerName.value;
      form.Email = this.Email.value;
      form.MobileNo = this.MobileNo.value;
      form.Email = this.Email.value;
      // form.Address = this.Address.value;
      form.BirthDay=this.BirthDay.value;
      form.BusinessName=this.BusinessName.value;
      form.Notes=this.Notes.value;
      form.ContactPerference=this.ContactPerference.value;
      form.id=this.id.value;
      form.DateTime=this.date.value;
      let merchantdata: UserPOSData = this.commonfunction.getUserPOSData();
      form.PosSubscriptionId = merchantdata.PosSubscriptionId;
    this.service.UpdateCustomer(form).subscribe(result => {
      console.log(" result - ", result);
      if (result != null) {
        if (result.ResponseText == null) { 
          localStorage.removeItem('Customerlist');
          swal("Updated", "Customer Updated Successfully", "success");  
          swal("Added", "Customer Added Successfully", "success");  
          this.router.navigate(["/pos/customer/manage"]);
        }
        else
        {
          swal("Duplicate",result.ResponseText, "warning");  
        }
      }
    });
  }

  newCustomer() {
    let form = {
      PosSubscriptionId:"",
    CustomerId :"",
    CustomerName  :"",
    Email  :"",
    MobileNo  :"",
    // Address  :"",
    BirthDay  :"",
    BusinessName  :"",
    Notes  :"",
    ContactPerference  :""
    };
    form.CustomerId = this.CustomerId.value;
    form.CustomerName = this.CustomerName.value;
    form.Email = this.Email.value;
    form.MobileNo = this.MobileNo.value;
    form.Email = this.Email.value;
    // form.Address = this.Address.value;
    form.BirthDay=this.BirthDay.value;
    // form.BusinessName=this.BusinessName.value;
    form.BusinessName=this.BusinessName.value;
    form.Notes=this.Notes.value;
    form.ContactPerference=this.ContactPerference.value;

    let merchantdata: UserPOSData = this.commonfunction.getUserPOSData();
    form.PosSubscriptionId = merchantdata.PosSubscriptionId;
    // alert(this.requestDate.value);
    // alert(this.dueDate.value);
    this.service.AddCustomer(form).subscribe(result => {
      console.log(" result - ", result);
      if (result != null) {
        if (result.ResponseText == null) { 
          localStorage.removeItem('Customerlist');
          swal("Updated", "Customer Updated Successfully", "success");  
          swal("Added", "Customer Added Successfully", "success");  
          this.router.navigate(["/pos/customer/manage"]);
        }
        else
        {
          swal("Duplicate",result.ResponseText, "warning");  
        }
      }
    });
  }
  customerName() {
    return this.CustomerName.hasError("required") ? "Customer Name is required"
      : this.CustomerName.hasError("pattern") ? "Customer name should be alphabets only" : "";
  }

  Emailerrorss() {
    // return this.email.hasError("required") ? "Email is required"
    // : this.email.hasError("pattern") ? "Email should be allow Correct Format" : "";


    return this.Email.hasError("pattern") ? "Please enter email address in Correct Format" : "";
  }

  phoneerrors() {
    return this.MobileNo.hasError("required") ? "Phone Number  is required"
      : this.MobileNo.hasError("pattern") ? "Phone Number should be numeric" : "";
   }


   BirthDayName() {
    return this.BirthDay.hasError("pattern") ? "Customer should be allow only alphabets" : "";
  }
  BusinessNames() {
    return this.BusinessName.hasError("required") ? "BusinessName is required"
      : this.BusinessName.hasError("pattern") ? "BusinessName be allow only alphabets" : "";
  }
  Noteserror() {
    return this.Notes.hasError("pattern") ? "Notes should be allow only alphabets" : "";
  }

  ContactPerferenceerrorss()
  {
    return this.ContactPerference.hasError("pattern") ? "Email should be Enter Correct Format" : "";
  }

  onKey()
  {
    this.isReadytoUpdateCustomer = true;
  }
}
